import { DownOutlined } from "@ant-design/icons";
import { Checkbox, Col, Empty, Row, Spin, Tree } from "antd";
import { useTranslation } from "react-i18next";
import { ModelFilter } from "react3l-common";
import { InputSearch } from "react3l-ui-library";
import { PermissionRoleDetailProps } from "../PermissionRoleView/PermissionRoleDetail";
import { usePermissionRoleTreeViewHook } from "./PermissionRoleTreeViewHook";

export default function PermissionRoleTreeView(
  props: PermissionRoleDetailProps
) {
  const { role, siteId, handleChangeAllField } = props;
  const [translate] = useTranslation();

  const {
    treeDataRef,
    onCheck,
    checkedKeys,
    menuFilter,
    handleChangeInputSearch,
    firstInitTreeData,
    checkedAll,
    handleCheckedAll,
  } = usePermissionRoleTreeViewHook(role, siteId, handleChangeAllField);
  return (
    <div
      style={{
        height: "500px",
      }}
    >
      <Row>
        <Col lg={1}></Col>
        <Col lg={13}>
          <InputSearch
            value={menuFilter?.search}
            classFilter={ModelFilter}
            placeHolder={translate("general.placeholder.search")}
            onChange={handleChangeInputSearch}
            animationInput={false}
          />
        </Col>
        <Col lg={1}></Col>
        <Col lg={7}>
          <Checkbox
            className="m-t--sm"
            disabled={menuFilter?.name?.contain}
            checked={checkedAll}
            onChange={handleCheckedAll}
          >
            <span>Chọn tất cả</span>
          </Checkbox>
        </Col>

        <Col lg={24} className="m-t--lg m-l--lg">
          {firstInitTreeData && role?.id ? (
            <Spin className="d-flex justify-content-center align-items-center" />
          ) : treeDataRef.current.length > 0 ? (
            <div
              style={{
                height: "400px",
                width: "90%",
                overflowY: "auto",
                overflowX: "hidden",
              }}
            >
              <Tree
                checkable
                onCheck={onCheck}
                treeData={treeDataRef.current}
                showLine={{ showLeafIcon: false }} // Disable leaf icons
                switcherIcon={<DownOutlined />}
                checkedKeys={checkedKeys}
              />
            </div>
          ) : (
            <Empty description="Vui lòng lưu vai trò để hiển thị danh sách quyền!" />
          )}
        </Col>
      </Row>
    </div>
  );
}
